<template>
  <div style="width: 100%">
    <v-data-table
      :headers="headers"
      :items="items"
      :height="items.length > 7 ? (32 * 7 + 32 + 16) : undefined"
      disable-pagination
      hide-default-footer dense
      style="white-space: nowrap"
    >
      <template v-slot:top v-if="toolbar">
        <v-toolbar flat dense>
          <v-toolbar-title>TITLE</v-toolbar-title>
          <v-divider class="mx-2" inset vertical/>
          <v-btn v-if="!readonly" @click="row_create" small class="ma-2" color="primary">Add</v-btn>
          <v-spacer/>
        </v-toolbar>
      </template>

      <template v-slot:item.days="{ item }">
        {{ Array.isArray(item.days) ? item.days.join(', ') : '' }}
      </template>

      <template v-if="!readonly" v-slot:item.actions="{item}">
        <v-icon @click="row_update(item)" class="mr-2" small>mdi-pencil</v-icon>
        <v-icon @click="row_copy(item)" class="mr-2" small color="teal lighten-1">
          mdi-content-copy
        </v-icon>
        <v-icon @click="row_moveup(item)" class="mr-2" small>mdi-arrow-up-thick</v-icon>
        <v-icon @click="row_movedown(item)" class="mr-2" small>mdi-arrow-down-thick</v-icon>
        <v-icon @click="row_remove(item)" class="mr-2" small>mdi-delete</v-icon>
      </template>
    </v-data-table>
    <r-bundle-christmas-dialog ref="dialog"/>
  </div>
</template>

<script>
import VueTypes from "vue-types";
import {ViewRules} from "@/common/ViewRules";
import {SmartOfferChristmasConfig} from "@/modules/redactor/models/smart-offer/bundle-christmas/SmartOfferChristmasConfig";

import RBundleChristmasDialog from "@/modules/redactor/views/smart-offer/bundle-christmas/r-bundle-christmas-dialog.vue";

export default {
  name: "r-bundle-christmas-table",
  components: {RBundleChristmasDialog},
  props: {
    items: VueTypes.arrayOf(SmartOfferChristmasConfig).isRequired,
    toolbar: VueTypes.bool.def(true),
    readonly: VueTypes.bool.def(false)
  },
  data: () => ({
    headers: [
      {text: "Name", value: "name"},
      {text: 'Days', value: 'days'},
      {text: '', value: 'actions', width: '100%', sortable: false, align: 'end'}
    ]
  }),
  computed: {
    empty() {
      return this.items.length === 0;
    }
  },

  methods: {
    row_create() {
      this.$refs['dialog'].show(ViewRules.CREATE)
        .then((data) => {
          this.items.push(data);
        }).catch(() => {
      });
    },
    row_copy(item) {
      this.$refs['dialog'].show(ViewRules.CREATE, item.clone())
        .then((data) => {
            this.items.push(data);
        }).catch(() => {
      });
    },
    row_update(item) {
      this.$refs['dialog'].show(ViewRules.UPDATE, item.clone())
        .then((data) => {
          const index = this.items.indexOf(item);
          this.items.splice(index, 1, data);
        }).catch(() => {
      });
    },
    row_remove(item) {
      this.$confirm("Are you sure you want to delete this item?").then(() => {
        const index = this.items.indexOf(item);
        this.items.splice(index, 1);
      });
    },
    row_moveup(item) {
      const index = this.items.indexOf(item);
      if (index > 0) {
        this.items.splice(index - 1, 2, this.items[index], this.items[index - 1]);
      }
    },
    row_movedown(item) {
      const index = this.items.indexOf(item);
      if (index < this.items.length - 1) {
        this.items.splice(index, 2, this.items[index + 1], this.items[index]);
      }
    }
  }
}
</script>
